import { render, staticRenderFns } from "./gongdan_record.vue?vue&type=template&id=b4cf282c&scoped=true&"
import script from "./gongdan_record.vue?vue&type=script&lang=js&"
export * from "./gongdan_record.vue?vue&type=script&lang=js&"
import style0 from "./gongdan_record.vue?vue&type=style&index=0&id=b4cf282c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4cf282c",
  null
  
)

export default component.exports